import axios from 'axios';
import * as XLSX from 'xlsx';

import { createNotification } from '../modules/notificationManager';

export const exportToExcel = async (url, fileName, showMessage) => {
  const baseURL = `${process.env.REACT_APP_API_URL}/api/`;
  const token = localStorage.getItem('access_token');
  const headers = { 'Content-Type': 'blob', Authorization: `Bearer ${token}` };
  const config = {
    method: 'GET',
    url: `${baseURL}${url}`,
    responseType: 'arraybuffer',
    headers,
  };

  try {
    const response = await axios(config);

    const outputFilename = fileName || `SubTaskReport_${new Date().toLocaleString()}.xlsx`;

    // If you want to download file automatically using link attribute.
    const url = URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();

    if (showMessage) {
      createNotification('success', 'Report exported successfully', 2500);
    }

    return {
      success: true,
    };
  } catch (error) {
    // Extract error message from various sources
    let errorMessage = 'Error exporting report';
    
    if (error.response?.data) {
      try {
        const buffer = new Uint8Array(error.response.data);
        const text = new TextDecoder().decode(buffer);
        const jsonData = JSON.parse(text);
        errorMessage = jsonData.detail || jsonData.message || errorMessage;
      } catch (e) {
        // If parsing fails, use status text
        errorMessage = error.response?.statusText || errorMessage;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    if (showMessage) {
      createNotification('error', errorMessage, 3000);
    }

    throw Error(error);
  }
};

export const exportCampReadinessToExcel = (data, selectedTab) => {
  const exportedBy = localStorage.getItem('user_fullName') || 'Unknown';
  const exportedAt = new Date().toLocaleString();

  const aoa = [
    ['Camp Readiness Report'],
    [],
    ['Exported By:', exportedBy],
    ['Exported At:', exportedAt],
    ['Public Zone:', selectedTab || 'All'],
    [],
    ['Office', 'Public Zone', 'Readiness %'],
    ...data.map(item => [
      item.office_name,
      item.public_zone_name,
      `${item.readiness_percentage}%`,
    ]),
  ];

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  // Column widths
  ws['!cols'] = [{ wch: 30 }, { wch: 20 }, { wch: 16 }];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Camp Readiness');

  const fileName = `CampReadiness_${selectedTab || 'All'}_${new Date().toLocaleDateString('en-GB').replace(/\//g, '-')}.xlsx`;
  XLSX.writeFile(wb, fileName);
  createNotification('success', 'Report exported successfully', 2500);
};
